import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField as MuiTextField } from '@mui/material';

import { Prefecture, City } from '../../types/api/MasterPrefectureApiType';
import { ChangeFieldItemInput, DeviceInfoInputRow } from '../../types/common/EstimateInquiryType';

// 見積依頼内容入力部品 設置場所 props
type FieldItemInput = {
    inputData: DeviceInfoInputRow; // 行データ
    setInputData: (value: ChangeFieldItemInput) => void; // setState
    prefectureList: Array<Prefecture>; // 都道府県
    cityList: Array<City>; // 市区群
};

// 見積依頼内容入力部品　設置場所
export const FieldItemInput: React.FC<FieldItemInput> = ({ inputData, setInputData, prefectureList, cityList }) => {
    // 市区群のsetState
    const [showCityList, setShowCityList] = useState<Array<City>>(cityList);

    // 都道府県選択に伴う、cityの絞り込み
    useEffect(() => {
        // 選択された都道府県IDで絞り込み
        const tempCityList = cityList.filter((row) => Number(row.prefecture_id) === Number(inputData.prefectureId));
        setShowCityList(tempCityList);
        // 初期値をsetState
        if (inputData.cityId === '' || inputData.cityId === undefined) {
            setInputData({ ...inputData, cityId: tempCityList[0]?.city_id, cityName: tempCityList[0]?.city_name });
        }
    }, [inputData.prefectureId]);

    // 都道府県選択時state
    const prefectureSelectOnChange = (prefecture: Prefecture) => {
        setInputData({
            ...inputData,
            prefectureId: prefecture.prefecture_id ?? '',
            prefectureName: prefecture.prefecture_name ?? '',
            cityId: '',
            cityName: '',
        });
    };

    // 市区群表示
    const selectCityValue = () => {
        // 選択された都道府県リスト
        const selectPrefCity = cityList.find((e) => Number(e.prefecture_id) === Number(inputData.prefectureId));
        // 選択cityIdを表示 cityIDが無ければ選択された都道府県リスト
        const selectCity = cityList.find((e) => Number(e.city_id) === Number(inputData.cityId)) ?? selectPrefCity;
        return selectCity;
    };

    return (
        <div className='field field_location'>
            <div className='field-item'>
                <div className='select'>
                    <Autocomplete
                        disablePortal
                        sx={{
                            width: 150,
                            '& .MuiInputBase-input.Mui-disabled': {
                                color: '#808da9',
                                WebkitTextFillColor: '#808da9',
                            },
                            '& .MuiAutocomplete-inputRoot.Mui-disabled': {
                                backgroundColor: 'hsl(0, 0%, 96%)',
                                cursor: 'not-allowed',
                            },
                            '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                            '& .Mui-disabled input': {
                                cursor: 'not-allowed',
                            },
                        }}
                        disableClearable
                        noOptionsText={'データなし'}
                        popupIcon={<></>}
                        options={prefectureList}
                        value={
                            prefectureList.find((e) => Number(e.prefecture_id) === Number(inputData.prefectureId)) ??
                            prefectureList[0]
                        }
                        defaultValue={prefectureList[Number(inputData.prefectureId)]}
                        getOptionLabel={(row) => row.prefecture_name}
                        filterOptions={(options, params) => {
                            // 入力内容でフィルタリング
                            const { inputValue } = params;
                            const filterList = options.filter((option) =>
                                option.select_search_string.includes(inputValue)
                            );
                            return filterList;
                        }}
                        renderInput={(params) => <MuiTextField {...params} className='select-input' />}
                        onChange={(_, newValue) => prefectureSelectOnChange(newValue)}
                    />
                </div>
                <div className='select'>
                    <Autocomplete
                        disablePortal
                        sx={{
                            width: 150,
                            '& .MuiInputBase-input.Mui-disabled': {
                                color: '#808da9',
                                WebkitTextFillColor: '#808da9',
                            },
                            '& .MuiAutocomplete-inputRoot.Mui-disabled': {
                                backgroundColor: 'hsl(0, 0%, 96%)',
                                cursor: 'not-allowed',
                            },
                            '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                            '& .Mui-disabled input': {
                                cursor: 'not-allowed',
                            },
                        }}
                        disableClearable
                        noOptionsText={'データなし'} // 検索結果がない場合
                        popupIcon={<></>}
                        options={showCityList}
                        value={selectCityValue()}
                        isOptionEqualToValue={(option, value) => option.city_id === value?.city_id}
                        getOptionLabel={(row) => row.city_name}
                        filterOptions={(options, params) => {
                            // 入力内容でフィルタリング
                            const { inputValue } = params;
                            const filterList = options.filter((option) =>
                                option.select_search_string.includes(inputValue)
                            );
                            return filterList;
                        }}
                        renderInput={(params) => <MuiTextField {...params} className='select-input' />}
                        onChange={(_, newValue) =>
                            setInputData({ ...inputData, cityId: newValue?.city_id, cityName: newValue?.city_name })
                        }
                    />
                </div>
            </div>
        </div>
    );
};
